module.exports = __webpack_public_path__ + "img/homepage_06.d8fa03cc.jpg";